export const GENERAL = {
  DOWNLOAD_PDF: 'Descargar PDF con toda la información',
  SEE_INFO: 'Ver información',
  HIDE_INFO: 'Ocultar',
  SEE_TABLE: 'Ver tabla',
  LAST_UPDATE_ON: 'Última actualización:',
  SEE_CHAPTER_HISTORY: 'Ver historial de actualizaciones',
  SEARCH_CHAPTER: 'Buscar en transparencia...',
  NO_ENTRIES_YET: 'Sin información por el momento',
  CTYPES: {
    IMAGE: 'IMAGE',
    PDF: 'PDF',
    TEXT: 'TEXT',
    TABLE: 'TABLE',
    XLSX: 'XLSX',
  }
}



// WEBPACK FOOTER //
// ./src/locales/es.js